import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { Header, Tabs, Container, PageContent, Alerts, PrivateComponent } from 'components';
import { Margin } from 'styled-components-spacing';
import { globalPropTypes } from 'helpers';
import { useTranslation } from 'react-i18next';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.yc.projects',
    url: '/ipma/projects',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.yc.projects.planning',
    path: '/ipma/projects/planning',
    key: 'planning',
  },
  {
    title: 'navigation.tabs.yc.projects.running',
    path: '/ipma/projects/running',
    key: 'running',
  },
  {
    title: 'navigation.tabs.yc.projects.completed',
    path: '/ipma/projects/completed',
    key: 'completed',
  },
];

const Projects = ({ routes, bar, userPermissions }) => {
  const { t } = useTranslation();
  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/ipma/projects', firstTabPath);

  return (
    <>
      <Header
        breadcrumbs={breadcrumbs}
        title={t('page.yc.projects.title')}
        renderActions={({ Button: ButtonRender }) => (
          <PrivateComponent
            permissions={{
              roles: ['ipma_project_manage_project'],
            }}
          >
            <ButtonRender secondary as={Link} to="/ipma/project/create">
              {t('page.yc.projects.createButton')}
            </ButtonRender>
          </PrivateComponent>
        )}
      />
      <Tabs items={tabs} />
      {renderExactRedirect()}
      <PageContent>
        <Container>
          <Margin bottom={{ md: 48 }}>
            <Alerts type="yc" />
          </Margin>
          {renderSubRoutes()}
        </Container>
      </PageContent>
    </>
  );
};

Projects.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  bar: PropTypes.shape({
    planning: PropTypes.number.isRequired,
    running: PropTypes.number.isRequired,
    completed: PropTypes.number.isRequired,
  }).isRequired,
  userPermissions: globalPropTypes.UserPermissions.isRequired,
};

Projects.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ ipma, user }) => ({
  bar: ipma.projects.bar,
  userPermissions: user.userPermissions,
});

export default connect(mapStateToProps, null)(Projects);
